export default {
  "DraggableItem": "_DraggableItem_1ngba_1",
  "DragHandle": "_DragHandle_1ngba_11"
};import "ni:sha-256;sAaMtr22TZz8k68JybyqZ_wUvxtPgCOtqPa7VReAIPg";